var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPlus = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 64 64"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M57.5 34.5h-24v24c0 1.1-.9 2-2 2s-2-.9-2-2v-24h-24c-1.1 0-2-.9-2-2s.9-2 2-2h24v-24c0-1.1.9-2 2-2s2 .9 2 2v24h24c1.1 0 2 .9 2 2s-.9 2-2 2"
})));
export default SvgPlus;